module.exports = __webpack_public_path__ + "img/gd.b1f94ed8.svg";